var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"#46659B","app":"","inset":""}},[_c('v-spacer'),_c('span',{staticClass:"white--text"},[_vm._v("©Blú Capital 2020")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }